// @ts-nocheck
import RadioGroup from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import useStepFormInputs from "@store/Library/Components/Bunzl/StepFormComponents/useStepFormInputs";
import React, { ChangeEventHandler } from "react";
import StepFormTextDisplayValues from "./StepFormDisplayValues";
import { StepFormCommonProps } from "./StepFormTextField";

interface StepFormRadioButtonsProps extends Omit<RadioGroupProps, "error">, StepFormCommonProps {
    children?: React.ReactNode;
}

const StepFormRadioButtons: React.FC<StepFormRadioButtonsProps> = ({
    children,
    hasSubmitted,
    inputKey,
    stepOverride,
    validation,
    disabled,
    ...otherProps
}) => {
    const required = !!otherProps?.required;
    const { value, editable, error, handleChange } = useStepFormInputs({
        inputKey,
        required,
        validation,
        stepOverride,
    });
    const internalHandleChange: ChangeEventHandler<HTMLInputElement> = event => {
        handleChange(event.target.value);
    };
    return (
        <>
            {editable && (
                <RadioGroup
                    errorProps={{ size: 14, weight: 400 }}
                    onChangeHandler={internalHandleChange}
                    horizontal
                    error={hasSubmitted ? error : undefined}
                    value={value ?? ""}
                    {...otherProps}
                >
                    {children}
                </RadioGroup>
            )}
            {!editable && (
                <StepFormTextDisplayValues
                    label={typeof otherProps.label === "string" ? otherProps.label : ""}
                    value={value ?? ""}
                    error={hasSubmitted ? error : undefined}
                />
            )}
        </>
    );
};

export default StepFormRadioButtons;
